import type { ArgsOf } from "@p0security/shared/types/access/index";
import { Access } from "@p0security/shared/types/access/index";

export const SelfHostedAccesses = {
  computer: Access({
    description: "Provision user access to an individual machine",
    label: "Machine",
    maturity: "ga",
    delegation: {},
    generated: {},
    parameters: {
      // TODO: Should be optional "environment"
      environmentId: {
        type: "dynamic",
        label: "Environment ID",
      },
      hostId: {
        type: "dynamic",
        label: "Host ID",
      },
      sudo: {
        type: "boolean",
        label: "Sudo",
        valueLabel: "Grant sudo access",
        optional: true,
      },
      publicKey: {
        type: "input",
        label: "Public key",
        optional: true,
      },
      hostname: {
        type: "generated",
        label: "Hostname",
      },
      clientId: {
        type: "generated",
        label: "Client ID",
      },
      publicIp: {
        type: "generated",
        label: "Public IP",
      },
      fingerprint: {
        type: "generated",
        label: "Fingerprint",
      },
      linuxUserName: {
        type: "generated",
        label: "Linux user name",
      },
    },
    render: {
      locator: "environmentId",
      policy: "sudo",
      resource: "hostId",
    } as const,
  }),
};

export type SelfHostedAccesses = typeof SelfHostedAccesses;
export type SelfHostedAccess = SelfHostedAccesses[keyof SelfHostedAccesses];
export type SelfHostedComputerAccess = SelfHostedAccesses["computer"];
export type SelfHostedComputerAccessArgs = ArgsOf<SelfHostedComputerAccess>;
